import userService from "../services/user.service";
import { toogleErrorMessage, toogleSuccessMessage } from "./alertMessage";
import { USER_LIST, USER_LIST_LOADER } from "./type";

export const usersDetails = (search, page, limit) => (dispatch) => {
  dispatch({ type: USER_LIST_LOADER, payload: true });
  return userService.userList(search, page, limit).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: USER_LIST, payload: resp.data });
    } else {
      dispatch({ type: USER_LIST_LOADER, payload: null });
    }
    return resp;
  });
};

export const blockUserAction = (id, isBlocked) => async (dispatch) => {
  return await userService.blockedUser(id).then((resp) => {
    if (resp.status === 200) {
      console.log(isBlocked,'isBlocked')
      const message = isBlocked
        ? "User unblocked successfully"
        : "User blocked successfully";

      dispatch(toogleSuccessMessage(message));

    } else {
      dispatch(
        toogleErrorMessage(
          resp.response?.data?.message || "Something went wrong"
        )
      );
    }
    return resp;
  });
};